module.exports = __webpack_public_path__ + "static/media/add-card.0dd176bc.svg";